"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getContentType_1 = require("../helpers/getContentType");
const getState_1 = require("../helpers/getState");
const entity_1 = require("../type/entity");
const baseZeroState_1 = require("../zeroStates/nodeZeroState/baseZeroState");
function updateDatesForChildrenStates(state, childrenStates) {
    let maxUpdatedTime = 0;
    let maxLastAccessedOnTime = 0;
    let minStartedOnTime = Number.MAX_SAFE_INTEGER;
    childrenStates.forEach((childState) => {
        const { updatedAt = '', lastAccessedOn = '', startedOn = '' } = childState;
        const updatedTime = new Date(updatedAt).getTime();
        const lastAccessedOnTime = new Date(lastAccessedOn).getTime();
        const startedOnTime = new Date(startedOn || '').getTime();
        if (updatedTime > maxUpdatedTime) {
            maxUpdatedTime = updatedTime;
        }
        if (lastAccessedOnTime > maxLastAccessedOnTime) {
            maxLastAccessedOnTime = lastAccessedOnTime;
        }
        if (startedOnTime < minStartedOnTime && startedOnTime !== new Date(baseZeroState_1.defaultDate).getTime()) {
            minStartedOnTime = startedOnTime;
        }
    });
    if (maxUpdatedTime !== 0) {
        state.updatedAt = new Date(maxUpdatedTime).toISOString();
    }
    if (maxLastAccessedOnTime !== 0) {
        state.lastAccessedOn = new Date(maxLastAccessedOnTime).toISOString();
    }
    if (minStartedOnTime !== Number.MAX_SAFE_INTEGER) {
        state.startedOn = new Date(minStartedOnTime).toISOString();
    }
}
/**
 * Updates lastAccessedOn, startedOn for non
 * leaf nodes.
 */
// @ts-ignore: maintain function signature
function updateAccessDates(command, user, content, states) {
    const state = getState_1.getStateByContentIdUserId(states, content._id, user.userId);
    const contentType = getContentType_1.getContentType(content);
    switch (contentType) {
        case entity_1.ContentType.SECTION:
        case entity_1.ContentType.COURSE: {
            const childrenStates = getState_1.getChildrenStatesForContentByUserId(states, content, user.userId);
            updateDatesForChildrenStates(state, childrenStates);
            break;
        }
        case entity_1.ContentType.CURRICULUM: {
            const childrenContents = content.offers;
            const childrenContentIds = childrenContents.map(c => c.offerId);
            const childrenStates = getState_1.getStatesForUserIdAndContentIds(states, childrenContentIds, user.userId);
            updateDatesForChildrenStates(state, childrenStates);
            break;
        }
        default:
            break;
    }
    return [];
}
exports.updateAccessDates = updateAccessDates;
//# sourceMappingURL=updateAccessDates.js.map